import { Injectable } from "@angular/core";
import { KeyboardValues } from "app/models/keyboard-values.model";

const COOKIE_PREVIOUS_ROUTE = "PREVIOUS_ROUTE";
const COOKIE_KEYBOARD_VALUE = "KEYBOARD_VALUE";
const COOKIE_INPUT_ID = "INPUT_ID";
const COOKIE_ROUTE = "ROUTE";

@Injectable({
  providedIn: "root",
})
export class KeyboardService {
  constructor() {}

  public setKeyboardValues(inputId: string, value: any, route: string) {
    localStorage.setItem(COOKIE_INPUT_ID, inputId);
    localStorage.setItem(COOKIE_KEYBOARD_VALUE, String(value));
    localStorage.setItem(COOKIE_ROUTE, route);
  }

  public getKeyboardValues(): KeyboardValues {
    const inputId = localStorage.getItem(COOKIE_INPUT_ID) ?? '';
    const route = localStorage.getItem(COOKIE_ROUTE) ?? '';
    const keyboardValue = localStorage.getItem(COOKIE_KEYBOARD_VALUE) ?? '';
    const keyboardValues: KeyboardValues = {
      route,
      inputId,
      keyboardValue,
    };
    return keyboardValues;
  }

  public checkKeyboardValues() {
    const value = this.getKeyboardValues();
    const okey =
      value.inputId != null &&
      value.inputId != undefined &&
      value.inputId != "" &&
      value.keyboardValue != null &&
      value.keyboardValue != undefined &&
      value.keyboardValue != "";
    return { okey, value };
  }

  public setRoute(route: string) {
    localStorage.setItem(COOKIE_PREVIOUS_ROUTE, route);
  }

  public getRoute(): string | null {
    return localStorage.getItem(COOKIE_PREVIOUS_ROUTE);
  }

  public clearKeyboardValues() {
    localStorage.removeItem(COOKIE_INPUT_ID);
    localStorage.removeItem(COOKIE_KEYBOARD_VALUE);
    localStorage.removeItem(COOKIE_ROUTE);
    localStorage.removeItem(COOKIE_PREVIOUS_ROUTE);
  }

  clearAll() {
    localStorage.clear();
  }
}
